export const view = (name: string) => {
  return () => import(`@/views/${name}.vue`);
};

export const viewModule = (name: string, page = 'index') => {
  return () => import(`@/modules/${name}/${page}.vue`);
}

